import { render, staticRenderFns } from "./CharHeader.vue?vue&type=template&id=c718e06c"
import script from "./CharHeader.vue?vue&type=script&lang=js"
export * from "./CharHeader.vue?vue&type=script&lang=js"
import style0 from "./CharHeader.vue?vue&type=style&index=0&id=c718e06c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports